import type { ComponentPropsWithoutRef } from "react"
import React from "react"
import { IconCircleQuestionOutline18 as HelpCircle } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

import type { IconType } from "."
import {
	IssueBacklogIcon,
	IssueCanceledIcon,
	IssueCompletedIcon,
	IssueDuplicateIcon,
	IssueStartedIcon,
	IssueTriageIcon,
	IssueUnstartedIcon,
} from "./issues"
import { PlannedIcon } from "./project-status/planned-icon"

export interface IssuePriorityIconProps extends ComponentPropsWithoutRef<"svg"> {
	status: string
	color?: string
}

export const IconMap: Record<string, IconType> = {
	backlog: IssueBacklogIcon,
	canceled: IssueCanceledIcon,
	completed: IssueCompletedIcon,
	duplicate: IssueDuplicateIcon,
	planned: PlannedIcon,
	paused: IssueBacklogIcon,
	started: IssueStartedIcon,
	triage: IssueTriageIcon,
	unstarted: IssueUnstartedIcon,
	closed: IssueCanceledIcon,
	review: IssueCompletedIcon,
}

export const IssueStatusIcon = React.memo(
	React.forwardRef<SVGSVGElement, IssuePriorityIconProps>(
		({ status, color, className, ...props }, ref) => {
			const Icon = IconMap[status]
			if (!Icon) {
				return (
					<HelpCircle
						ref={ref}
						{...props}
						className={cn("flex-none", className)}
					/>
				)
			}

			return (
				<Icon
					ref={ref}
					{...props}
					color={color}
					className={cn("flex-none", className)}
				/>
			)
		},
	),
)
